import { appEnv, AppVariant } from 'app/core/environment';
import { Opt } from 'app/tools/general.types';
import _ from 'lodash';
import {
  ChatEventType,
  RepairCase,
} from '../repairer/api-repairer.types';
import { UserRole } from './api-user.types';

export const mapUserRoleFromEventType: Record<
  ChatEventType,
  UserRole
> = {
  [ChatEventType.CONSUMER_MESSAGE]: UserRole.CONSUMER,
  [ChatEventType.WARRANTY_CLAIM]: UserRole.CONSUMER,
  [ChatEventType.REPAIRER_MESSAGE]: UserRole.REPAIRER,
  [ChatEventType.BOT_MESSAGE]: UserRole.REPAIRER,
  [ChatEventType.CONTEXT_UPDATE]: UserRole.REPAIRER,

  // Quotes phase
  [ChatEventType.DIAGNOSIS_QUOTE]: UserRole.REPAIRER,
  [ChatEventType.DIAGNOSIS_QUOTE_AGREED]: UserRole.CONSUMER,
  [ChatEventType.DIAGNOSIS_QUOTE_DECLINE]: UserRole.CONSUMER,
  [ChatEventType.DIAGNOSIS_QUOTE_ACCEPT]: UserRole.CONSUMER,
  [ChatEventType.REPAIR_QUOTE]: UserRole.REPAIRER,
  [ChatEventType.REPAIR_QUOTE_AGREED]: UserRole.CONSUMER,
  [ChatEventType.REPAIR_QUOTE_DECLINE]: UserRole.CONSUMER,
  [ChatEventType.REPAIR_QUOTE_ACCEPT]: UserRole.CONSUMER,

  // Repair phase
  [ChatEventType.REPAIR_STARTED]: UserRole.REPAIRER,
  [ChatEventType.REPAIR_COMPLETED]: UserRole.REPAIRER,
  [ChatEventType.REPAIR_FAILED]: UserRole.REPAIRER,

  // Post repair
  [ChatEventType.CONSUMER_REVIEW]: UserRole.CONSUMER,

  // Payment done
  [ChatEventType.CONSUMER_PAYMENT_DONE]: UserRole.REPAIRER,

  // Early exits
  [ChatEventType.CONSUMER_ABANDONED]: UserRole.CONSUMER,
  [ChatEventType.REPAIRER_ABANDONED]: UserRole.REPAIRER,
};

export const mapChatEventTypeFromUserRole: Record<
  UserRole,
  ChatEventType
> = {
  [UserRole.CONSUMER]: ChatEventType.CONSUMER_MESSAGE,
  [UserRole.REPAIRER]: ChatEventType.REPAIRER_MESSAGE,
};

export const currentUserRole = {
  [AppVariant.CONSUMER]: UserRole.CONSUMER,
  [AppVariant.BUSINESS]: UserRole.REPAIRER,
}[appEnv.APP_VARIANT];

export const defaultEventSendType =
  mapChatEventTypeFromUserRole[currentUserRole];

export const getOtherUsersName = (
  repairCase: Opt<RepairCase>,
  nameFormat: 'full-name' | 'first-name' = 'first-name'
): string => {
  const { firstName = '', lastName = '' } =
    repairCase?.userDetails || {};
  const optLastName =
    (nameFormat === 'full-name' && lastName[0]) || '';

  const consumerFullName = `${firstName} ${optLastName}`.trim();
  const consumerEName = _.lowerCase(
    repairCase?.userDetails.email.split('@')[0]
  );

  const repairerName = repairCase?.repairerDetails.displayName || '';
  const consumerName =
    consumerFullName || _.capitalize(consumerEName) || '';

  return {
    [AppVariant.BUSINESS]: consumerName,
    [AppVariant.CONSUMER]: repairerName,
  }[appEnv.APP_VARIANT];
};
